module.exports = {
      id: "edit-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "svg-sprite.svg#edit",
      toString: function () {
        return this.url;
      }
    }